import { makeStyles, tokens } from '@fluentui/react-components';

export const useBottomBarStyles = makeStyles({
  bar: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    paddingTop: tokens.spacingVerticalXS,
    paddingRight: tokens.spacingHorizontalXS,
    paddingBottom: tokens.spacingVerticalXS,
    paddingLeft: tokens.spacingHorizontalS,
    borderTop: `1px solid ${tokens.colorNeutralStroke2}`,
  },
});
